/**
 * Mock flight data for Track Flights page
 */

export const mockFlights = [
  {
    id: '1',
    clientName: 'Robert Chen',
    tailNumber: 'N234JT',
    route: {
      from: 'LAX',
      to: 'JFK'
    },
    status: 'in_flight',
    departureDate: new Date('2025-10-17T08:00:00'),
    trustScore: 95,
    isAOG: false
  },
  {
    id: '2',
    clientName: 'Amanda Rodriguez',
    tailNumber: 'N567PR',
    route: {
      from: 'DFW',
      to: 'ORD'
    },
    status: 'under_maintenance',
    departureDate: new Date('2025-10-18T12:00:00'),
    trustScore: 88,
    isAOG: false
  },
  {
    id: '3',
    clientName: 'James Smith',
    tailNumber: 'N890GH',
    route: {
      from: 'SEA',
      to: 'BOS'
    },
    status: 'pending',
    departureDate: new Date('2025-10-19T15:30:00'),
    trustScore: 92,
    isAOG: false
  },
  {
    id: '4',
    clientName: 'David Lee',
    tailNumber: 'N678ZU',
    route: {
      from: 'SFO',
      to: 'IAD'
    },
    status: 'at_departure',
    departureDate: new Date('2025-10-20T14:15:00'),
    trustScore: 87,
    isAOG: false
  },
  {
    id: '5',
    clientName: 'Sophia Brown',
    tailNumber: 'N123AB',
    route: {
      from: 'MIA',
      to: 'LGA'
    },
    status: 'in_flight',
    departureDate: new Date('2025-10-21T09:00:00'),
    trustScore: 94,
    isAOG: false
  },
  {
    id: '6',
    clientName: 'Michael Johnson',
    tailNumber: 'N456CD',
    route: {
      from: 'DEN',
      to: 'PHX'
    },
    status: 'in_flight',
    departureDate: new Date('2025-10-17T10:30:00'),
    trustScore: 91,
    isAOG: false
  },
  {
    id: '7',
    clientName: 'Emily Davis',
    tailNumber: 'N789EF',
    route: {
      from: 'ATL',
      to: 'DTW'
    },
    status: 'pending',
    departureDate: new Date('2025-10-18T16:00:00'),
    trustScore: 65,
    isAOG: false
  },
  {
    id: '8',
    clientName: 'Christopher Wilson',
    tailNumber: 'N321GH',
    route: {
      from: 'LAS',
      to: 'SLC'
    },
    status: 'at_departure',
    departureDate: new Date('2025-10-19T11:45:00'),
    trustScore: 89,
    isAOG: true
  },
  {
    id: '9',
    clientName: 'Jessica Martinez',
    tailNumber: 'N654IJ',
    route: {
      from: 'BWI',
      to: 'CLT'
    },
    status: 'in_flight',
    departureDate: new Date('2025-10-21T13:20:00'),
    trustScore: 93,
    isAOG: false
  },
  {
    id: '10',
    clientName: 'Daniel Anderson',
    tailNumber: 'N987KL',
    route: {
      from: 'PDX',
      to: 'SAN'
    },
    status: 'pending',
    departureDate: new Date('2025-10-24T08:30:00'),
    trustScore: 90,
    isAOG: false
  },
  {
    id: '11',
    clientName: 'Sarah Taylor',
    tailNumber: 'N147MN',
    route: {
      from: 'IAH',
      to: 'MSP'
    },
    status: 'at_departure',
    departureDate: new Date('2025-10-25T14:00:00'),
    trustScore: 88,
    isAOG: false
  }
];

/**
 * Status configuration mapping
 */
export const statusConfig = {
  in_flight: {
    label: 'In Flight',
    color: 'green',
    textColor: 'text-green-600',
    bgColor: 'bg-green-50',
    borderColor: 'border-green-200',
    icon: 'RiPlaneLine'
  },
  under_maintenance: {
    label: 'Under Maintenance',
    color: 'red',
    textColor: 'text-red-600',
    bgColor: 'bg-red-50',
    borderColor: 'border-red-200',
    icon: 'RiErrorWarningLine'
  },
  pending: {
    label: 'Pending',
    color: 'orange',
    textColor: 'text-orange-600',
    bgColor: 'bg-orange-50',
    borderColor: 'border-orange-200',
    icon: 'RiTimeLine'
  },
  at_departure: {
    label: 'At Departure Airport',
    color: 'blue',
    textColor: 'text-blue-600',
    bgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    icon: 'RiMapPinLine'
  }
};
